import React from "react";
import { Link } from "react-router-dom";
import { Title, Button, Container, Group, Text } from "@mantine/core";

import UseStyles from "./useStyles";

export default function NotFound() {
  const { classes } = UseStyles();

  return (
    <Container className={classes.root}>
      <div className={classes.label}>404</div>
      <Title className={classes.title}>Page not found</Title>
      <Text
        color="dimmed"
        size="lg"
        align="center"
        className={classes.description}
      >
        Page you are trying to open does not exist. You may have mistyped the
        address, or the page has been moved to another URL. If you think this is
        an error contact support.
      </Text>
      <Group position="center">
        <Button className={classes.button} size="md" component={Link} to="/" replace={true}>
          Take me back to home page
        </Button>
      </Group>
    </Container>
  );
}
